import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sort",
})
export class SortingPipe implements PipeTransform {
  transform(data: any[], field: string, type: string) {
    //console.log(data, field, type)
    data.sort((a: any, b: any) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return -1;
      } else {
        return 0;
      }
    });
    return data;
  }
}
